module.exports = __webpack_public_path__ + "static/media/Half.df1cff93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animals/test/Half.jpg
// module id = 884
// module chunks = 0